
































































































import { Component, Vue } from 'vue-property-decorator';
import {
  Form, Field, Popup, Area, Toast,
} from 'vant';
import investmentPageApi from '@/api/investmentPage';
import { AddressObj, areaListObj, obj } from './types';

@Component({
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Area.name]: Area,
  },
})
export default class InvestmentPage extends Vue {
  showArea: Boolean = false

  areaList: areaListObj = {
    province_list: {},
    city_list: {},
    county_list: {},
  }

  poiAddressParams: Object = {
    provinceCode: '',
    provinceName: '',
    cityCode: '',
    cityName: '',
    districtCode: '',
    districtName: '',
  }

  name: String = ''

  phone: String = ''

  poiAddress: String = ''

  submitting: Boolean = false

  isLeaveElectricity: Boolean = false

  async mounted() {
    await this.getAreaList();
  }

  get channelType(): number { // 1 到综
    const { channelType = 1 } = this.$route.query;
    return Number(channelType);
  }

  async getAreaList() {
    const { error, data }: ApiResponse.MDPData = await investmentPageApi.getAreaList();
    if (!error && data) {
      this.transformAreaList(data.list);
    }
  }

  transformAreaList(data: Array<obj>) {
    data.forEach((item1: obj) => {
      this.areaList.province_list[item1.code] = item1.name;
      item1.children.forEach((item2: obj) => {
        if (item2.code !== '0') this.areaList.city_list[item2.code] = item2.name;
        item2.children.forEach((item3: obj) => {
          if (item3.code !== '0') this.areaList.county_list[item3.code] = item3.name;
        });
      });
    });
  }

  async onSubmit() {
    const errors = await (this.$refs.form as any).validate().catch((e: Error) => e);
    if (errors) {
      Toast.fail('请填写全部信息');
    } else {
      if (this.submitting) return;
      this.submitting = true;
      await this.onSave();
      this.submitting = false;
    }
  }

  async onSave() {
    const params = {
      name: this.name,
      phone: this.phone,
      channelType: this.channelType,
      resourceEntrance: 1, // 1-APP 2-PC 3-其他
      ...this.poiAddressParams,
    };
    const { error, data }: ApiResponse.MDPData = await investmentPageApi.onSave(params);
    if (!error && data) {
      this.isLeaveElectricity = true;
    }
  }

  onConfirm(value: Array<AddressObj>) {
    this.poiAddressParams = {
      provinceCode: value[0].code,
      provinceName: value[0].name,
      cityCode: value[1].code,
      cityName: value[1].name,
      districtCode: value[2].code,
      districtName: value[2].name,
    };
    this.poiAddress = value[0].name + value[1].name + value[2].name;
    if (value[0].name === value[1].name) {
      this.poiAddress = value[0].name + value[2].name;
    }
    this.showArea = false;
  }
}
